import { deleteFile, uploadFile } from "../Services/DashboardApi";

export const handleUpload = async (file, folderName) => {
  try {
    const fileUrl = await uploadFile(file, folderName);
    return fileUrl;
  } catch (err) {
    console.error("Error uploading file:", err);
    throw err;
  }
};

export const handleDelete = async (fileUrl, folderName) => {
  try {
    if (!fileUrl) return false;

    await deleteFile(fileUrl, folderName);
    return true;
  } catch (error) {
    console.error("Error deleting file:", error);
    throw error;
  }
};
